import getInboundTransmissionsRequest from '../requests/getInboundTransmissionsRequest';
import getOutboundTransmissionsRequest from '../requests/getOutboundTransmissionsRequest';
import moment from 'moment';

async function executeGetInboundTransmissions({ commit }, datesPayload ) {
	let searchFilter = createSearchFilter(datesPayload.fromDate, datesPayload.toDate);
	let transmissions = await getInboundTransmissionsRequest(searchFilter);
	commit('setInboundTransmissions', transmissions);
}

async function executeGetOutboundTransmissions({ commit }, datesPayload ) {
	let searchFilter = createSearchFilter(datesPayload.fromDate, datesPayload.toDate);
	let transmissions = await getOutboundTransmissionsRequest(searchFilter);
	commit('setOutboundTransmissions', transmissions);
}

function createSearchFilter(fromDateValue, toDateValue) {
	return {
		fromDate: toYYYYMMDDHHmm(fromDateValue),
		toDate: toYYYYMMDDHHmm(toDateValue)
	};
}

function toYYYYMMDDHHmm(date) {
	return moment(date, 'YYYYMMDDHHmm').format('YYYYMMDDHHmmss');
}

export default { executeGetInboundTransmissions, executeGetOutboundTransmissions };